import { ColumnViewModel } from '../../shared/column-types';

export const numGenesAssociatedToDisease_SUMMARY: ColumnViewModel = {
  columns: [
    'geneSymbol',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiID',
    'geneEnsemblIDs',
    'geneDescription',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'geneDPI',
    'geneDSI',
    'genepLI',
    'geneNcbiType',
    'pathwayName',
    'pathwayID',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'EL',
    'numCTs',
  ],
  defaultVisible: [
    'geneSymbol',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'geneDPI',
    'geneDSI',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'numCTs',
  ],
};
